export default class ProductCardWishlist extends HTMLElement {
  constructor() {
    super()

    this.button = this.querySelector('.prd-Card_WishlistButton')

    if (!this.button) return

    this.isInWishlist = false
    this.isLoading = false

    this.init()
  }

  async init() {
    await this.waitForSwym()
    await this.checkWishlistStatus()

    this.showButton()
    this.setupListeners()
  }

  waitForSwym() {
    return new Promise((resolve) => {
      if (window._swat && window._swat.platform) {
        resolve()
      } else {
        const checkSwym = setInterval(() => {
          if (window._swat && window._swat.platform) {
            clearInterval(checkSwym)
            resolve()
          }
        }, 100)
      }
    })
  }

  async checkWishlistStatus() {
    try {
      const wishlistItems = await this.getWishlistItems()
      this.isInWishlist = wishlistItems.some(item =>
        item.epi.toString() === this.variantId.toString()
      )

      if (this.isInWishlist) {
        this.setActiveState()
      }
    } catch (error) {
      console.error('Error checking wishlist status:', error)
    }
  }

  getWishlistItems() {
    return new Promise((resolve) => {
      window._swat.fetch(function(products) {
        resolve(products || [])
      })
    })
  }

  showButton() {
    this.button.setAttribute('aria-hidden', 'false')
    this.button.setAttribute('data-swym-loaded', 'true')
  }

  setupListeners() {
    if (!this.button) return

    this.button.addEventListener('click', this.handleClick.bind(this))

    if (!window._swat || !window._swat.evtLayer) return

    window._swat.evtLayer.addEventListener(
      window._swat.JSEvents.addedToWishlist,
      this.onWishlistAdded.bind(this)
    )

    window._swat.evtLayer.addEventListener(
      window._swat.JSEvents.removedFromWishlist,
      this.onWishlistRemoved.bind(this)
    )
  }

  async handleClick(e) {
    e.stopImmediatePropagation()
    e.preventDefault()

    if (this.isLoading) return

    this.isLoading = true

    try {
      if (this.isInWishlist) {
        await this.removeFromWishlist()
      } else {
        await this.addToWishlist()
      }
    } catch (error) {
      console.error('Wishlist action failed:', error)
    } finally {
      this.isLoading = false
    }
  }

  async addToWishlist() {
    return new Promise((resolve, reject) => {
      window._swat.addToWishList({
        epi: parseInt(this.variantId),
        empi: parseInt(this.productId),
        du: `${window.location.origin}${this.productUrl}`
      }, (response) => {
        this.isInWishlist = true
        this.setActiveState()

        resolve(response)
      }, (error) => {
        console.error('Swym addToWishList error:', error)
        reject(error)
      })
    })
  }

  async removeFromWishlist() {
    return new Promise((resolve, reject) => {
      window._swat.removeFromWishList({
        epi: parseInt(this.variantId),
        empi: parseInt(this.productId),
      }, (response) => {
        if (response) {
          this.isInWishlist = false
          this.setInactiveState()

          resolve(response)
        } else {
          console.error('Swym removeFromWishlist error')
          reject(new Error('Failed to remove from wishlist'))
        }
      })
    })
  }

  setActiveState() {
    this.button.setAttribute('aria-pressed', 'true')
    this.button.setAttribute('data-in-wishlist', 'true')

    const srText = this.button.querySelector('.util-ScreenReaderOnly')

    if (!srText) return

    srText.textContent = `Remove ${this.productTitle || 'product'} from wishlist`
  }

  setInactiveState() {
    this.button.setAttribute('aria-pressed', 'false')
    this.button.setAttribute('data-in-wishlist', 'false')

    const srText = this.button.querySelector('.util-ScreenReaderOnly')

    if (!srText) return

    srText.textContent = `Add ${this.productTitle || 'product'} to wishlist`
  }

  onWishlistAdded(event) {
    const epiString = event.detail?.d?.epi.toString()

    if (epiString && epiString !== this.variantId.toString()) return

    this.isInWishlist = true
    this.setActiveState()
  }

  onWishlistRemoved(event) {
    const epiString = event.detail?.d?.epi.toString()

    if (epiString && epiString !== this.variantId.toString()) return

    this.isInWishlist = false
    this.setInactiveState()
  }

  get productId() {
    return this.button.getAttribute('data-product-id')
  }

  get variantId() {
    return this.button.getAttribute('data-variant-id')
  }

  get productUrl() {
    return this.button.getAttribute('data-product-url')
  }

  get productTitle() {
    return this.button.getAttribute('data-product-titl')
  }
}

customElements.define('product-card-wishlist', ProductCardWishlist)
